import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { CUSTOMER_CONNECTIONS_ROUTE } from "./CustomerConnectionDetailsConstants";

const CustomerConnectionDetailsList = Loadable(
    lazy(() =>
        import("./CustomerConnectionDetailsList").then(({ CustomerConnectionDetailsList }) => ({
            default: CustomerConnectionDetailsList,
        }))
    )
);

export const CustomerConnectionDetailsRoutes = [
    {
        path: CUSTOMER_CONNECTIONS_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess={true}
                moduleIds={[ALLOWED_MODULES.CUSTOMER_CONNECTIONS]}
            >
                <CustomerConnectionDetailsList />
            </AuthorizedRoute>
        ),
    },
];